import { useTranslation } from 'react-i18next';
import { Col, Form, Row, Spin, Tag } from "antd";
import { FC } from "react";
import CustomCard from "../../../../custom-card/CustomCard";
import "../lecturer-detail/lecturerDetail.scss";
interface LecturerDetailProps {
  lecturerDetail: any;
  specialized: string[];
  academicLevel: string[];
  regency: string[];
  loadingDetail: boolean;
}

const LecturerDetail: FC<LecturerDetailProps> = ({
  lecturerDetail,
  specialized,
  academicLevel,
  regency,
  loadingDetail,
}) => {
    const { t } = useTranslation();
  return (
    <section className="wrapper-settings category-management-detail">
      <div className="setting-lecturer wrapper-inside">
        <CustomCard className="header-card" title={t("Thông tin giảng viên")}>
          {loadingDetail ? (
            <div className="statistic-course-content statistic-course-loading">
              <Spin size="large" />
            </div>
          ) : (
            <section>
              <Form.Item className="setting-item" name="name" label={t("Tên giảng viên")}>
                <p className="lecturer-content">{lecturerDetail?.name}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="university" label={t("Đơn vị công tác")}>
                <p className="lecturer-content">{lecturerDetail?.universityName}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="code" label={t("Mã giảng viên")}>
                <p className="lecturer-content">{lecturerDetail?.code}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="gender" label={t("Giới tính")}>
                <p className="lecturer-content">{lecturerDetail?.gender ? (t(lecturerDetail?.gender, lecturerDetail?.gender) as string) : ""}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="department" label={t("Khoa", "Khoa")}>
                <p className="lecturer-content">{lecturerDetail?.industryGroupInfo?.name}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="domicile" label={t("Nguyên quán")}>
                <p className="lecturer-content">{lecturerDetail?.provinceDto?.name}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="specialized" label={t("Chuyên ngành")}>
                <div className="lecturer-content">
                  {specialized?.map((item: any) => (
                    <Tag key={item}>
                      {item}
                    </Tag>
                  ))}
                </div>
              </Form.Item>
              <Form.Item className="setting-item" name="academicLevel" label={t("Trình độ học vấn")}>
                <div className="lecturer-content">
                  {academicLevel?.map((item: any) => (
                    <Tag key={item}>
                      {item}
                    </Tag>
                  ))}
                </div>
              </Form.Item>
              <Form.Item className="setting-item" name="regency" label={t("Chức vụ")}>
                <div className="lecturer-content">
                  {regency?.map((item: any) => (
                    <Tag key={item}>
                      {item}
                    </Tag>
                  ))}
                </div>
              </Form.Item>
              <Form.Item className="setting-item" name="email" label="Email">
                <p className="lecturer-content">{lecturerDetail?.email}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="phone" label={t("Điện thoại liên hệ")}>
                <p className="lecturer-content">{lecturerDetail?.phoneNumber}</p>
              </Form.Item>
            </section>
          )}
        </CustomCard>
      </div>
    </section>
  );
};

export default LecturerDetail;